<template>
  <div class="bg-white rounded-2xl p-4 shadow border w-full">
    <h2 class="text-md font-semibold mb-2">Tiket per Creator (Bulan Ini)</h2>
    
    <div class="flex justify-center">
      <!-- Tambahkan max-w dan hapus w-full -->
      <div class="relative w-full h-[320px] sm:h-[400px]">
        <Doughnut :data="chartData" :options="chartOptions" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Tooltip,
  ArcElement,
} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(ArcElement, Tooltip, ChartDataLabels)

const props = defineProps({
  ticket_by_creator_month: {
    type: Array,
    default: () => [],
  }
})

const labels = props.ticket_by_creator_month.map(item => item.name)
const data = props.ticket_by_creator_month.map(item => item.count)
const total = data.reduce((a, b) => a + b, 0)

const colors = [
  '#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd',
  '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf',
  '#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00',
  '#ffff33', '#a65628', '#f781bf', '#999999', '#00bcd4',
  '#cddc39', '#795548', '#ff5722', '#607d8b'
]

const chartData = {
  labels,
  datasets: [
    {
      backgroundColor: colors,
      data,
    }
  ]
}

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: '40%',
  plugins: {
    legend: {
      display: false,
    },
    datalabels: {
      anchor: 'end',
      align: 'end',
      formatter: (value) => {
        const percent = (value / total) * 100
        return percent >= 2 ? `${value} (${percent.toFixed(1)}%)` : ''
      },
      font: {
        weight: 'bold',
        size: 10,
      },
      clip: true,
    },
    tooltip: {
      callbacks: {
        label: ctx => `${ctx.label}: ${ctx.raw} tiket`
      }
    }
  }
}
</script>

<style scoped>
div[class*='chartjs'] {
  height: 400px !important;
}
</style>
